module.exports = __webpack_public_path__ + "img/Tutorial_TextDeskriptor.1277e88e.jpg";